export const NODE_TYPES = {
  ACTION: 'action',
  DECISION: 'decision',
  END: 'end',
  START: 'start',
};
